module.exports = __webpack_public_path__ + "assets/img/46fc65aedb34069c3589e4f4534ee19b.webp";